module.exports = __webpack_public_path__ + "6ffaec0fc18c2d9d760b7703fdcab010.pdf";